/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ichmchteammittagessenteilnehmen4Inputs */

const en__field_ichmchteammittagessenteilnehmen4 = /** @type {(inputs: _Field_Ichmchteammittagessenteilnehmen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you participate at lunch?`)
};

const de__field_ichmchteammittagessenteilnehmen4 = /** @type {(inputs: _Field_Ichmchteammittagessenteilnehmen4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte teilen Sie uns mit, ob Sie beim Mittagessen teilnehmen?`)
};

/**
* | output |
* | --- |
* | "Do you participate at lunch?" |
*
* @param {_Field_Ichmchteammittagessenteilnehmen4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ichmchteammittagessenteilnehmen4 = /** @type {((inputs?: _Field_Ichmchteammittagessenteilnehmen4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ichmchteammittagessenteilnehmen4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ichmchteammittagessenteilnehmen4(inputs)
	return de__field_ichmchteammittagessenteilnehmen4(inputs)
});
export { _field_ichmchteammittagessenteilnehmen4 as "_field_ichMchteAmMittagessenTeilnehmen" }